const ROUTES = {
  TESTS: "/tests",
  TEST: "/tests/:locationId/:testId/:date",
  HOME: "/",
  DASHBOARD: "/dashboard",
  USERS: "/users",
  USER: "/users/:id",
  COMPANIES: "/companies",
  EMPLOYEES: "/employees",
  EMPLOYEE: "/employees/:locationId/:identifier",

  COMPANY: "/companies/:id",
  LOCATIONS: "/locations",
  LOCATION: "/companies/:companyId/locations/:locationId",
  LOGIN: "/login",
  NEW_PASSWORD: "/new_password",
};

export default ROUTES;
